module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA0klEQVQ4jc3TPUoDQRiH8d9+BCFVkEAghTcQLAQRwTPkCDlGIGewSpfW0iNsp72HEIJdJJ1fyaTYDWqys2sj+MA088z8mXlf3qQoigkusETqiw3O8IInJN9cQAfLHNcY4d0hM9zjrsbBbVql112Gt8j+jkVaPfsocmDnY2RN8lf8eUCC5wa/ylsCPjHGqZ9tpGzlVVtAwDEGyGpcty2ggxs8RPy0rQYBwwbf+x9tDMpq1xGqFWOTKv+4jhzI8NEQ0M/xiLlybPfH+RwnuHQ4zjletxbhJ6khC3AxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/54.png
// module id = av3Q
// module chunks = 0